module.exports = __webpack_public_path__ + "img/Diakrit.bae4822e.png";